import React from "react"
import Expansion from "components/ExpansionComponent";
import styles from "../style.js"
import { withStyles } from '@material-ui/core';
import Picker from "storybookComponents/Picker";
import moment from "moment"
import "moment-timezone"

export const ApproverComponent = ({ expanded, handleExpandedPanel, approverSettings, classes }) => {
  const renderHeaderIcon = (open) => {
    if (!open && approverSettings && approverSettings.approverEmails) {
      return <div className={classes.headerIcon}>{approverSettings.approverEmails.length}</div>;
    } else {
      return null;
    }
  };
  return (
    <Expansion
      expanded={expanded}
      handleExpandedPanel={handleExpandedPanel}
      header="Approvers"
      name="approvers"
      headerIcon={renderHeaderIcon}
    >
      <div>
        <div className={classes.textApprover}>
          Each of the below approvers will receive an event approval request. Once they approve, it
          will be published.
        </div>
        <div className={classes.emailflex}>
          {approverSettings.approverEmails.map((email) => (
            <div className={classes.emailItem}>{email}</div>
          ))}
        </div>
      </div>
    </Expansion>
  );
};
const PublishEvent = ({
  classes,
  date,
  handleDate,
  approverSettings,
  userIsApprover,
  timezoneString,
  timezoneAbbr,
  minValidDate,
}) => {
  const [expanded, setExpanded] = React.useState("date");
  const handleExpandedPanel = (panel) => {
    if (panel === expanded) setExpanded("");
    else setExpanded(panel);
  };

  return (
    <div>
      <Expansion
        expanded={expanded === "date"}
        name="date"
        handleExpandedPanel={handleExpandedPanel}
        header="Select publish date & time"
        subtitle="The event would be published on property website at scheduled date & time, only when it is approved."
      >
        <div id="hyly-datePicker" className={classes.textField}>
          <Picker
            timezoneAbbr={timezoneAbbr}
            format={true}
            type="datetime"
            icon={true}
            handleChange={handleDate}
            placeholderText="Date & Time"
            defaultValue={date}
            timezoneString={timezoneString}
            minValidDate={minValidDate}
          />
        </div>
      </Expansion>
      {approverSettings.approvalRequired && !userIsApprover && (
        <div className={classes.approversExpansion}>
          <div className={classes.divider}></div>
          <ApproverComponent
            expanded={expanded === "approvers"}
            handleExpandedPanel={handleExpandedPanel}
            approverSettings={approverSettings}
            classes={classes}
          />
        </div>
      )}
    </div>
  );
};
export default withStyles(styles)(PublishEvent);